import {
  getOrderFieldConfRequest,
  requestRecreateRequest,
  getUsersList,
  getOrderFlowStepRequest,
  requestOrderCreate,
  requestWorkOrderModify,
  getJobConfigAPI,
  getCvmConfigList,
  createOrderPreCheckRequest,
  getClbBackendTarget
} from '../../../api/api'
import {getUrl} from "../../../utils/global/geturl";
import ajax from "../../../api/ajax";  // 导入封装后的axios请求

const state = {
  tableData: [],
  tableLoading: false,
  notify: "",
}

const getters = {}

const actions = {
  async getOrderConf ({commit}, params) {
    return getOrderFieldConfRequest(getUrl(params)).then(response => response)
  },
  async getOrderFlowStep ({commit}, params) {
    return getOrderFlowStepRequest(getUrl(params)).then(response => response)
  },
  async orderCreateMethod ({commit}, params) {
    return requestOrderCreate(params).then(response => response)
  },
  async workOrderModify ({commit}, params) {
    return requestWorkOrderModify(params).then(response => response)
  },
  async getJobConfig ({commit}, params) {
    return getJobConfigAPI(params).then(response => response, (response, err) => {response = err})
  },
  async getCvmConfig({commit},params){
    return getCvmConfigList(getUrl(params)).then(response => response)
  },
  async getClbBackendTargetHandler({commit},params){
    return getClbBackendTarget(getUrl(params)).then(response => response)
  },
  async reCreateOrder({commit},params) {
    return requestRecreateRequest(params).then(response => response)
  },
  async checkCreateOrder({commit},params){
    return createOrderPreCheckRequest(params).then(response => response)
  }

};

const mutations = {
  changeInputTableValue(state,data){
    console.log("state",state)

    state.tableData = data
  },
  changeLoadingValue(state,data){
    state.tableLoading = data
  },
  changeNotify(state,data){
    state.notify = data
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/createorder/createorder.js